import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=4d5d65de&scoped=true&"
import script from "./proxy.vue?vue&type=script&lang=js&"
export * from "./proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d65de",
  null
  
)

export default component.exports